import React, { ReactNode, use, useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import MuiAppBar, { AppBarProps as MuiAppBarProps } from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import MuiDrawer from "@mui/material/Drawer";
import { Divider, Drawer as MobileDrawer } from "@mui/material";
import SideNavContent from "./SideNav/SideNavContent";
import HeaderNavMenu from "./Header/HeaderNavMenu";
import DashboardHeader from "./Header/DashboardHeader";
//@ts-ignore
import useAuthStore from "@/store/Auth/useAuthStore";
import { isMatchingRoute } from "@/lib/auth.util";
import { useRouter } from "next/router";
import DashboardHeaderMobile from "./Header/DashboardHeaderMobile";

interface AppBarProps extends MuiAppBarProps {
  open?: boolean;
}

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})<AppBarProps>(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth})`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const drawerWidth = "20em";

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
}));

const DashboardLayout: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] =
    React.useState<null | HTMLElement>(null);

  const isMenuOpen = Boolean(anchorEl);
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);
  const { currentLang } = useAuthStore();

  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const mobileMenuId = "primary-search-account-menu-mobile";
  const [open, setOpen] = React.useState(true); // Changed to true for desktop
  const [openCart, setOpenCart] = React.useState(false);

  const [width, setWidth] = useState<number | null>(null);

  function handleWindowSizeChange() {
    setWidth(window?.innerWidth);
  }
  useEffect(() => {
    if (window) {
      setWidth(window?.innerWidth);
      window.addEventListener("resize", handleWindowSizeChange);
      return () => {
        window.removeEventListener("resize", handleWindowSizeChange);
      };
    }
  }, []);

  const isMobile = width ? width <= 1000 : false;
  const router = useRouter();
  const path = router.asPath.split("?")[0];
  const isShowCartDrawer = isMatchingRoute(path, new Set(["/pos"]));
  const [loaderTimout, setLoaderTimout] = useState(false);
  setTimeout(() => {
    setLoaderTimout(true);
  }, 500);

  const toggleDrawer = () => {
    setOpen(!open);
  };

  return (
    loaderTimout && (
      <Box className="flex  flex-row relative h-screen ">
        <Drawer
          PaperProps={{
            sx: {
              backgroundColor: "white",
              color: "black",
            },
          }}
          sx={{
            "& .MuiDrawer-paper": {
              boxSizing: "border-box ",
              width: open ? drawerWidth : `5rem`,
            },
          }}
          className={`${isMobile ? "hidden" : "block"}`}
          variant="permanent"
          open={open}
        >
          <SideNavContent
            setOpen={setOpen}
            open={open}
            toggleDrawer={toggleDrawer}
            isDrawerOpen={open}
            isMobile={isMobile}
          />
        </Drawer>

        {isMobile && (
          <MobileDrawer
            sx={{
              "& .MuiDrawer-paper": {
                boxSizing: "border-box ",
                width: drawerWidth,
              },
            }}
            PaperProps={{
              sx: {
                backgroundColor: "white",
                color: "black",
              },
            }}
            ModalProps={{
              keepMounted: true,
            }}
            variant="temporary"
            open={open && isMobile}
            onClose={() => {
              setOpen(false);
            }}
          >
            <SideNavContent
              setOpen={setOpen}
              open={open}
              toggleDrawer={toggleDrawer}
              isDrawerOpen={open}
              isMobile={isMobile}
            />
          </MobileDrawer>
        )}

        <HeaderNavMenu
          anchorEl={mobileMoreAnchorEl}
          id={mobileMenuId}
          isMenuOpen={isMobileMenuOpen}
          handleMenuClose={handleMobileMenuClose}
          isMobile={true}
          setOpen={setOpen}
        />

        <HeaderNavMenu
          setOpen={setOpen}
          anchorEl={anchorEl}
          id="account-menu"
          isMobile={false}
          isMenuOpen={isMenuOpen}
          handleMenuClose={handleMenuClose}
        />
        <Box
          component="main"
          style={{ direction: currentLang ? currentLang : "ltr" }}
          className={`items-center flex-1  relative h-full`}
        >
          <div className="flex flex-col h-full justify-center">
            <DashboardHeader open={open} isMobile={isMobile} />
            <div
              className={`${
                open
                  ? isMobile
                    ? "w-[100vw]"
                    : "w-[calc(100%-20rem)] "
                  : isMobile
                    ? "w-[100vw]"
                    : "w-[calc(100%-5rem)]"
              } flex-1 p-[1rem] md:p-2 pt-0 md:pt-0 md:ml-auto overflow-hidden `}
            >
              {children}
            </div>
          </div>
          {/* <HomeContactSectionComponent /> */}
        </Box>
      </Box>
    )
  );
};

export default DashboardLayout;
